/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAwsAccessKeyProtocol extends models.ServiceAccountCredentialsBaseForAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAwsAccessKeyProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAwsAccessKeyProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAwsAccessKeyProtocol>): ServiceAccountCredentialsForAwsAccessKeyProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForAwsAccessKeyProtocol(), model);
        ServiceAccountCredentialsForAwsAccessKeyProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAwsAccessKeyProtocol>): ServiceAccountCredentialsForAwsAccessKeyProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForAwsAccessKeyProtocol.newInstance(<ServiceAccountCredentialsForAwsAccessKeyProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAwsAccessKeyProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAwsAccessKeyProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAwsAccessKeyProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAwsAccessKeyProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Access Key Id. This is a required field.
     */
    access_key: string;

    /**
     * Secret Access Key Id. This is a required field.
     */
    secret_key: string;

    /**
     * Access Key Id to access S3 bucket in which CUR export available.
     */
    s3_access_key: string;

    /**
     * Secret Access Key Id to access S3 bucket in which CUR export is available.
     */
    s3_secret_key: string;

}
